import Flags from "common/constants/flags";

/**
 * Format a page title with environment specific prefixes.
 */
export default function getPageTitle(title?: string | number): string {
  let env = "";
  if (Flags.GIT_BRANCH === "master") {
    env = "";
  } else if (Flags.GIT_BRANCH === "stage") {
    env = "[STAGE] ";
  } else if (Flags.GIT_BRANCH === "qa") {
    env = "[QA] ";
  } else if (Flags.GIT_BRANCH === "demo1") {
    env = "[DEMO1] ";
  } else if (Flags.GIT_BRANCH === "demo2") {
    env = "[DEMO2] ";
  } else if (Flags.GIT_BRANCH === "develop") {
    env = "[DEV] ";
  } else if (Flags.DB_ENV === "pr" || Flags.COGNITO_ENV === "pr") {
    env = "[PR] ";
  } else if (/^sandbox\d+$/.test(Flags.GIT_BRANCH)) {
    env = `[${Flags.GIT_BRANCH.toUpperCase()}] `;
  } else {
    env = "[LOCAL] ";
  }

  if (title) {
    return `${env}Higharc - ${title}`;
  }

  return `${env}Higharc`;
}
